const theme = {
  // Primary color scheme (Red tones)
  primary: "#e53a47",
  primary1: "#ee5a5f", // lighter
  primary2: "#f37075",
  primary3: "#f78b92",
  primary4: "#fab3b9",
  primary5: "#fde2e3", // lightest background

  secondary: "#193659",
  secondary1: "#27466b",
  dark: "#273256",
  light: "#fff",
  text: "#8f9fbc",
  navy: "#1d3557",
  bg: "#F5F8FA",
  lightBg: "#25233f",
  error: "#ff3f3f",
  blue: "#2147CA",
  success: "#008000",
  border: "#eaeaea",
  secColor: "#b88403",
  gary1: "#a9a9a9",
  shadow: "0px 0px 30px 0px rgba(82, 63, 105, 0.05)",
};

export default theme;
